// =====================================
//
//   home banner
//   Author: Gray
//   createtime: 2016 / 02 / 16
//   updatetime: 2016 / 02 / 16
//
// =====================================

window.InifECApp.directive('homeBanner', ['$rootScope', function($rootScope) {

	var _dir = {};

	var link = function(scope, element, attrs) {

    	var bindCarousel = function() {
            var $owl = $(element);
            $owl.owlCarousel({
                loop:true,
                autoplay:true,
                autoplayTimeout:7000,
                autoplayHoverPause:true,
                items : 1,
                dots: true,
                dotsContainer : ".dot-content",
                dotData : true,
                lazyLoad: true,
            });

            var $dotContent = $(element).parent().find('.dot-content'),
                $dots = $dotContent.find('.dot-button');

            if($dots.length > 0){
                for(var i = 0 ; i < $dots.length ; i++){
                    bindDotsMouseEnterEvent($owl, $($dots[i]), i);
                }
            }
    	}

        var bindDotsMouseEnterEvent = function($owl, $dot, index) {
            $dot.bind('mouseenter', function(event){
                if($owl){
                    $owl.trigger('to.owl.carousel', [index, 300]);
                }
            });
        }

        var createHtml = function() {

            for(var i = 0; i < scope.homeBanner.length; i++) {
                var image = getIndexADRotionImage(scope.homeBanner[i]);

                image = image.replace('https://', '//');
                image = image.replace('http://', '//');
                image = image.replace('/medium', '/large');
                
                var linkurl = scope.homeBanner[i].linkurl;

                // var html = '<a class="image" style="background-image: url(' + image + ')"'
                var html = '<a class="image owl-lazy" data-src="' + image + '"'

                if(linkurl && linkurl != '') {
                    html += ' href="' + linkurl + '"';
                }

                if(scope.homeBanner[i].isLinkTargetSelf) {
                    html += ' ></a>';
                } else {
                    html += ' target="_blank"></a>';
                }

                $(element).append(html);
            }

            bindCarousel();
        }

        var createSingleHtml = function() {

            for(var i = 0; i < scope.homeBanner.length; i++) {
                var image = getIndexADRotionImage(scope.homeBanner[i]);

                image = image.replace('https://', '//');
                image = image.replace('http://', '//');
                image = image.replace('/medium', '/large');

                var linkurl = scope.homeBanner[i].linkurl;

                var html = '<a class="image" style="background-image: url(' + image + ')"'

                if(linkurl && linkurl != '') {
                    html += ' href="' + linkurl + '"';
                }

                if(scope.homeBanner[i].isLinkTargetSelf) {
                    html += ' ></a>';
                } else {
                    html += ' target="_blank"></a>';
                }

                $(element).append(html);
            }
        }

        var getIndexADRotionImage = function(adblock) {
            
            if(!adblock || !adblock.coverUrl) {
                return "about:blank";
            }

            return adblock.coverUrl;
        }

        var init = function() {

            if(Array.isArray(scope.homeBanner)){

                if(scope.homeBanner.length > 1) {
                    createHtml();
                } else if(scope.homeBanner.length === 1) {
                    createSingleHtml();
                }
            }
        }

        scope.$watchCollection("homeBanner", init);

    	//==========================
        //  Events
        //==========================

        //==========================
        //  Members
        //==========================

        //==========================
        //  Methods
        //==========================

        //==========================
        //  Init
        //==========================
        // init();

	};

	_dir.restrict = 'A';
	_dir.scope = {
        homeBanner: "="
    };
	_dir.link = link;

	return _dir;

}]);
